import { useState } from 'react';
import EmojiPickerReact, { EmojiClickData, EmojiStyle } from 'emoji-picker-react';

interface EmojiPickerProps {
  value: string;
  onChange: (emoji: string) => void;
}

export function EmojiPicker({ value, onChange }: EmojiPickerProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    onChange(emojiData.emoji);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 p-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors w-full sm:w-auto"
      >
        <span className="text-3xl">{value || '😀'}</span>
        <span className="text-sm text-gray-600 whitespace-nowrap">
          {value ? 'Klik untuk ganti' : 'Pilih emoji'}
        </span>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 mt-2 z-50">
            <EmojiPickerReact
              onEmojiClick={handleEmojiClick}
              emojiStyle={EmojiStyle.NATIVE}
              width={320}
              height={400}
              skinTonesDisabled
            />
          </div>
        </>
      )}
    </div>
  );
}
